// Visual tokens shared by the Temp, Vent and Energy tabs (docs/energy-tab-redesign.md "Visual tokens").

export const INK = '#0b0b0b';
export const INK_SOFT = '#3d3d3a';
export const SECONDARY = '#52514e';
export const MUTED = '#6b6a65';
export const FAINT = '#8a8984'; // small source labels, disabled chips
export const HAIRLINE = '#ecebe6';
export const HAIRLINE_STRONG = '#e1e0d9';
export const ROW_LINE = '#f1f0ec'; // between table rows
export const PAGE_BG = '#f4f4f1';
export const CARD_BG = '#fcfcfb';
export const CARD_SHADOW = '0 0 0 1px rgba(11,11,11,0.06)';
export const CARD_SHADOW_RAISED = '0 0 0 1px rgba(11,11,11,0.06), 0 1px 3px rgba(11,11,11,0.05)';
export const SAVING_GREEN = '#006300';
export const DOT = { good: '#0ca30c', warning: '#fab219', critical: '#d03b3b', off: '#c3c2b7' };

// Warm / cold text (trend arrows, min / max).
export const UP = '#b4461b';
export const DOWN = '#1c5cab';

// Alerts and "something is wrong" pills.
export const ALERT = { bg: '#fbe9e9', ring: '#f3c4c4', fg: '#8c1d1d', strong: '#b42828', fill: '#d03b3b' };
export const WARN = { bg: '#fdf3dc', fg: '#5c3d00', strong: '#8a6100' };
export const OK_TINT = '#e6f4ea';

// CO2: one line per uHoo room (in the order the snapshot lists them), threshold lines.
export const CO2_COLORS = ['#6250d6', '#0f8c8c', '#eb6834', '#8a8984'];
export const CO2_GOOD_LINE = '#eda100';
export const CO2_HIGH_LINE = '#e34948';

// Ventilation level: the chart line and the plan-strip tints per level.
export const VENT_COLOR = '#0f8c8c';
export const VENT_TINT = '#d5eeee';
export const LEVEL_TINTS = { away: '#ecebe6', low: '#bfe3e3', middle: '#5fb8b8', high: '#0f8c8c' };

export const ZERO_LINE = '#2a78d6'; // dashed 0 °C line
